import React from 'react'

import OurSystemPolicyPage from './our-system-policy-page'

export default function OurSystemPolicy() {
    return <OurSystemPolicyPage />
}
